import type { Ref } from 'vue';

import type { ILanguage } from '@modules/i18n/types';
import { useLanguages, useLocale } from '@modules/i18n/composables';
import { useI18nStore } from '@modules/i18n/store';

export interface TheLanguageSelectorComposable {
  setLocale(value: string): Promise<void>;
  interfaceLanguages: Ref<ILanguage[]>;
  currentLocale: Ref<string>;
}

export default function useTheLanguageSelector(): TheLanguageSelectorComposable {
  const { setLocale } = useI18nStore();
  const { currentLocale } = useLocale();

  const { interfaceLanguages } = useLanguages();

  return {
    setLocale,
    interfaceLanguages,
    currentLocale,
  };
}
